/**
 * @generated SignedSource<<ae9ee67aaa28e66449ac5d5a5da9893a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountid",
        "variableName": "accountId"
      }
    ],
    "kind": "ScalarField",
    "name": "getfloatbalance",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FloatBalanceTileQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FloatBalanceTileQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1c9bee55439d51c7c6f6f52f324d5cb4",
    "id": null,
    "metadata": {},
    "name": "FloatBalanceTileQuery",
    "operationKind": "query",
    "text": "query FloatBalanceTileQuery(\n  $accountId: UUID!\n) {\n  getfloatbalance(accountid: $accountId)\n}\n"
  }
};
})();

node.hash = "457ddfb86c89aa6ef6c46b8413f99e74";

module.exports = node;
